import React, { useMemo } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useUserData } from "../../../hooks/useUserData";
import PageBreadcrumb from "../../common/PageBreadcrumb/PageBreadcrumb";
import {
  parsePermissions,
  hasPermission,
  getAllPermissionKeys,
} from "../../../utils/permissionUtils";
import { parseCapaContextFromSearchParams } from "./capaConstants";
import CapaCreateForm from "./CapaCreateForm";

const CapaCreate = () => {
  const { userData } = useUserData();
  const [searchParams] = useSearchParams();

  const ctx = useMemo(
    () => parseCapaContextFromSearchParams(searchParams),
    [searchParams],
  );

  const isSystemAdmin = userData?.Role === "System Administrator";
  const userPermissions = isSystemAdmin
    ? getAllPermissionKeys()
    : parsePermissions(userData?.Permission || "");
  const canCreateCapa =
    !!userData &&
    (isSystemAdmin || hasPermission(userPermissions, "ADD_CAPA"));

  if (!userData) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: 200 }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!canCreateCapa) {
    return <Navigate to="/notification-center" replace />;
  }

  return (
    <div>
      <PageBreadcrumb
        items={[
          { label: "Home", path: "/notification-center" },
          { label: "CAPA", path: "/capa" },
          { label: "Create" },
        ]}
      />
      <CapaCreateForm context={ctx} variant="page" />
    </div>
  );
};

export default CapaCreate;
